const packageJSON = require('../package.json');

const { name, applicationName } = packageJSON;

module.exports = {
  vault: {
    url: `https://vault.peya.co/v1/secret/web-micro-site-${name}/dev`,
    enabled: true,
  },
  apiGateway: {
    url: 'http://localhost:12034',
    hostUrl: 'client-api-gateway.live.peja.co',
    timeout: 5000,
  },
  countryServices: {
    url: 'http://localhost:9501',
    hostUrl: 'countries-service.live.peja.co',
    timeout: 5000,
  },
  authServices: {
    url: 'http://localhost:9140',
    hostUrl: 'auth.live.peja.co',
    timeout: 5000,
  },
  locationService: {
    url: 'http://localhost:9145',
    hostUrl: 'locations-service.live.peja.co',
    timeout: 5000,
  },
  locationModuleFederation: {
    id: 'webLocation',
    moduleName: 'Location',
    manifest: '/mfe/web-location',
  },
  redis: {
    webApps: {
      host: 'localhost',
      port: 6379,
      cookieName: `${applicationName}.${name}.sid`,
      sessionName: `${applicationName}.${name}`,
      envName: 'local',
      cookieConfig: {
        httpOnly: false,
        maxAge: 5400000,
      },
    },
    web: {
      host: 'localhost',
      port: 6379,
      cookieName: `${applicationName}.${name}.sid`,
      sessionName: `${applicationName}.${name}`,
      envName: 'local',
      cookieConfig: {
        httpOnly: false,
        maxAge: 5400000,
      },
    },
  },
  metrics: {
    enabled: true,
    sampleRate: 1,
    clientName: 'console',
    events: [
      'LOADED_EMPTY_FILTER',
      'BT_FILTER_CLICK',
      'ITEM_CLICK',
      'ITEM_TOP_POSITION_CLICK',
      'ITEM_SECOND_RANGE_CLICK',
      'ITEM_THIRD_RANGE_CLICK',
      'ITEM_FOURTH_RANGE_CLICK',
      'VENDOR_SECOND_RANGE_CLICK',
      'VENDOR_THIRD_RANGE_CLICK',
      'VENDOR_FOURTH_RANGE_CLICK',
      'DELIVERY_TIME_FILTER_CLICK',
      'DISTANCE_FILTER_CLICK',
      'RANKING_FILTER_CLICK',
      'TERMS_AND_CONDITIONS_CLICK',
      'BACK_BUTTON_CLICK',
      'VENDOR_TOP_POSITION_CLICK',
      'VENDOR_CLICK',
      'LOADED_EMPTY_STATE',
      'SERVER_ERROR',
      'CLIENT_ERROR',
      'LOADED_EMPTY_ITEM',
      'LOADED_ERROR_ITEM',
    ],
  },
  fwf: {
    httpRequestTimeout: 30000,
    flagTimeToLive: 1,
    localFwfUrl: 'https://fwf-client-api.dev.peja.co',
  },
  resources: {
    url: 'https://stg-web-commons.pystatic.com',
    js: [
      'https://stg-web-commons.pystatic.com/react/17.0.2/development.js',
      'https://stg-web-commons.pystatic.com/react-dom/17.0.2/development.js',
    ],
  },
};
